<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<option value="https://www.amazon.com">Amazon</option>
          </select>
        </div>
        <div class="datebox">
          <select  class="form-control text-uppercase">
            <option>Coffee</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
       <div class="righcontent wrapitem">
        	<div class="datebox" style="float:right">
          <button @click="backToSov" style="width:max-content;float:right" class="btn btn-block weavrpurple" type="button">
            <i class="fa fa-arrow-left"></i>
            <span style="font-size:13px"> Back</span>
          </button>
        </div>
      </div>
  	</div>
    <div class="container-fluid ">
      <div class="">
        <div class="card p-2">
          <div class="amd-legend"> 
          
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffb9b9!important"></i>
              <span>nescafe</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #c7e0ff!important"></i>
              <span>bru</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffd0f5 !important"></i>
              <span>blue tokai coffee roasters</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #edf2fb!important"></i>
              <span>davidoff</span>
            </div>
          </div>  
          <table id="myTable2" class="table table-striped table-bordered">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in rows_details"  :key="i" :class="{'markitamd':r['brand'] == 'nescafe',
                'markitintel':r['brand'] == 'bru','markitsnap':r['brand'] == 'blue tokai coffee roasters','markitna':r['brand'] == 'davidoff'}">
                <td v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table> 
        </div>   
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'sovdetail',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website:localStorage.selected_website,
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      columns_details:[
        {label: 'Rank', field: 'order'},
        {label: 'Page', field: 'page'},
        {label: 'Brand', field: 'brand'},
        {label: 'Name', field: 'product_name',sortable: false},
        {label: 'Price', field: 'price',sortable: false},
        {label: 'Offer', field: 'offer',sortable: false},
        {label: 'Reviews', field: 'reviews'},
        {label: 'Ratings', field: 'ratings'}
      ],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false
    }
  },
  mounted()
  {
    this.website_details()
  },
  methods: {
    backToSov()
    { 
      window.location = '#/sov-summary'

    },
    showHeroChange(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      $('#myTable2').DataTable().destroy();
      localStorage.selected_website = this.selected_website
      this.website_details()
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      const url = "/api/websites/details"
      this.$http.post(url, { "website": this.selected_website,"timestamp":this.date.startDate }).then(response => {
        let resData = [
            {
              "order": 1,
              "price": "Rs 486",
              "offer": "Rs 540",
              "page": 1,
              "link": "https://www.amazon.in/Nescaf%C3%A9-Classic-Coffee-200g-Glass/dp/B06XCJ1SZP/",
              "page_count": 48,
              "reviews": 421,
              "ratings": 4.5,
              "image_count": 0,
              "product_name": "Nescafe Classic Coffee, 200g Dawn Jar",
              "item_id": "B06XCJ1SZP",
              "brand": "nescafe"
            },
            {
              "order": 2,
              "price": "Rs 290",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Nescaf%C3%A9-Classic-Coffee-100g-Free/dp/B01HOBPEKI/",
              "page_count": 48,
              "reviews": 1842,
              "ratings": 4.3,
              "image_count": 0,
              "product_name": "Nescafe Classic Coffee, 100g with Free Red Mug",
              "item_id": "B01HOBPEKI",
              "brand": "nescafe"
            },
            {
              "order": 3,
              "price": "Rs 340",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Bru-Instant-Coffee-200g/dp/B00649B4EM/",
              "page_count": 48,
              "reviews": 694,
              "ratings": 4.4,
              "image_count": 0,
              "product_name": "Bru Instant Coffee, 200g",
              "item_id": "B00649B4EM",
              "brand": "bru"
            },
            {
              "order": 4,
              "price": "Rs 465",
              "offer": "Rs 550",
              "page": 1,
              "link": "https://www.amazon.in/Davidoff-Rich-Aroma-Coffee-100g/dp/B0013BHG84/",
              "page_count": 48,
              "reviews": 423,
              "ratings": 4.5,
              "image_count": 0,
              "product_name": "Davidoff Cafe Rich Aroma Instant Coffee Jar, 100 g",
              "item_id": "B0013BHG84",
              "brand": "davidoff"
            },
            {
              "order": 5,
              "price": null,
              "offer": "Rs 460",
              "page": 1,
              "link": "https://www.amazon.in/Continental-Coffee-Xtra-Instant-Powder/dp/B01N0AO8RI/",
              "page_count": 48,
              "reviews": 1328,
              "ratings": 4.3,
              "image_count": 0,
              "product_name": "Continental Coffee Xtra Instant Coffee Powder 200gm Pouch",
              "item_id": "B01N0AO8RI",
              "brand": "continental coffee"
            },
            {
              "order": 6,
              "price": "Rs 875",
              "offer": "Rs 900",
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Gold-Smooth-Coffee-Powder/dp/B07K6L3KC6/",
              "page_count": 48,
              "reviews": 977,
              "ratings": 4.4,
              "image_count": 0,
              "product_name": "Nescafe Gold Blend Rich and Smooth Coffee Powder, 200g Glass Jar",
              "item_id": "B07K6L3KC6",
              "brand": "nescafe gold"
            },
            {
              "order": 7,
              "price": "Rs 513",
              "offer": "Rs 540",
              "page": 1,
              "link": "https://www.amazon.in/Nescaf%C3%A9-Cheeky-Mug-Kit-Pack/dp/B08K9VM145/",
              "page_count": 48,
              "reviews": 26,
              "ratings": 4.6,
              "image_count": 0,
              "product_name": "Nescafe Cheeky Mug Kit Pack - NESCAFÉ Classic Instant Coffee with Free Morning Zombie Cheeky Mug (Limited Edition), 200 g",
              "item_id": "B08K9VM145",
              "brand": "nescafe"
            },
            {
              "order": 8,
              "price": "Rs 468",
              "offer": "Rs 490",
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Classic-Coffee-Stabilio-200g/dp/B01MY2Y30O/",
              "page_count": 48,
              "reviews": 684,
              "ratings": 4.5,
              "image_count": 6,
              "product_name": "Nescafe Classic Coffee, 200g Stabilo Pack",
              "item_id": "B01MY2Y30O",
              "brand": "nescafe"
            },
            {
              "order": 9,
              "price": "Rs 360",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Colombian-Brew-Coffee-Instant-Chocolate/dp/B07P9HNRY8/",
              "page_count": 48,
              "reviews": 169,
              "ratings": 4.1,
              "image_count": 0,
              "product_name": "Colombian Brew Coffee Pure Instant 50g, Vanilla Instant 50g, Double Chocolate Mocha 50g, Buy 2 Get 1 Free, 150 g",
              "item_id": "B07P9HNRY8",
              "brand": "colombian brew coffee"
            },
            {
              "order": 10,
              "price": "Rs 269",
              "offer": "Rs 275",
              "page": 1,
              "link": "https://www.amazon.in/Bru-Gold-Instant-Coffee-100g/dp/B00GPJF85C/",
              "page_count": 48,
              "reviews": 1103,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Bru Gold Instant Coffee, 100% Pure Granulated Coffee, 100 g",
              "item_id": "B00GPJF85C",
              "brand": "bru"
            },
            {
              "order": 11,
              "price": "Rs 600",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Tata-Grand-Strong-Instant-Coffee/dp/B08662DF84/",
              "page_count": 48,
              "reviews": 87,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Tata Grand Strong Instant Coffee - 1kg Pack",
              "item_id": "B08662DF84",
              "brand": "tata"
            },
            {
              "order": 12,
              "price": "Rs 550",
              "offer": "Rs 1,100",
              "page": 1,
              "link": "https://www.amazon.in/Continental-SPECIALE-Instant-Coffee-200gm/dp/B071W5J8QW/",
              "page_count": 48,
              "reviews": 687,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Continental Coffee Speciale Pure Instant Coffee 200gm Bag in Box ( Buy 1 + Get 1 Free )",
              "item_id": "B071W5J8QW",
              "brand": "continental coffee"
            },
            {
              "order": 13,
              "price": "Rs 490",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Nescaf%C3%A9-Classic-Coffee-200g-Stabilo/dp/B00VJZ0OCY/",
              "page_count": 48,
              "reviews": 502,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Nescafe Classic Coffee, 200g",
              "item_id": "B00VJZ0OCY",
              "brand": "nescafe"
            },
            {
              "order": 14,
              "price": "Rs 155",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Green-Label-500g-Poly-Pack/dp/B0022H79MG/",
              "page_count": 48,
              "reviews": 650,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Bru Green Label Filter Coffee - Ground & Roast, 500 g",
              "item_id": "B0022H79MG",
              "brand": "bru"
            },
            {
              "order": 15,
              "price": "Rs 1,085",
              "offer": "Rs 1,100",
              "page": 1,
              "link": "https://www.amazon.in/Davidoff-Aroma-Grande-Instant-Coffee/dp/B07TKV36JX/",
              "page_count": 48,
              "reviews": 54,
              "ratings": 4.5,
              "image_count": 1,
              "product_name": "Davidoff Cafe Rich Aroma Grande Cuvee Instant Coffee - Pack of 2 Jar, 2 x 100 g",
              "item_id": "B07TKV36JX",
              "brand": "davidoff"
            },
            {
              "order": 16,
              "price": "Rs 486",
              "offer": "Rs 540",
              "page": 1,
              "link": "https://www.amazon.in/Nescaf%C3%A9-Classic-Coffee-Glass-200g/dp/B06XCDZXC1/",
              "page_count": 48,
              "reviews": 115,
              "ratings": 4.6,
              "image_count": 6,
              "product_name": "Nescafe Classic Coffee, 200G Dawn Jar",
              "item_id": "B06XCDZXC1",
              "brand": "nescafe"
            },
            {
              "order": 17,
              "price": "Rs 319",
              "offer": "Rs 325",
              "page": 1,
              "link": "https://www.amazon.in/Country-Bean-Instant-Hazelnut-Flavoured/dp/B07C62CJZF/",
              "page_count": 48,
              "reviews": 896,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Country Bean Instant Coffee Powder | Hazelnut Flavoured Coffee 60 g",
              "item_id": "B07C62CJZF",
              "brand": "country bean"
            },
            {
              "order": 18,
              "price": "Rs 475",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/NESCAF%C3%89-GOLD-Soluble-Coffee-Limited/dp/B08HP7PT9H/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "NESCAFÉ GOLD Pure Soluble Coffee Powder, with Free Glass Mug (Limited Edition Pack), 100g",
              "item_id": "B08HP7PT9H",
              "brand": "nescafe gold"
            },
            {
              "order": 19,
              "price": null,
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Neuherbs-Organic-Coffee-Powder-Management/dp/B06X6K9L43/",
              "page_count": 48,
              "reviews": 1130,
              "ratings": 3.8,
              "image_count": 6,
              "product_name": "Neuherbs Green Coffee Beans powder For Weight Loss: 200 G, (Pack Of 2)",
              "item_id": "B06X6K9L43",
              "brand": "neuherbs"
            },
            {
              "order": 20,
              "price": "Rs 641",
              "offer": "Rs 650",
              "page": 1,
              "link": "https://www.amazon.in/Levista-Extra-Strong-Instant-Coffee/dp/B07PSGRNM2/",
              "page_count": 48,
              "reviews": 65,
              "ratings": 4.3,
              "image_count": 2,
              "product_name": "Levista Extra Strong Instant Coffee (Pouch) (1 Kg)",
              "item_id": "B07PSGRNM2",
              "brand": "levista"
            },
            {
              "order": 21,
              "price": "Rs 287",
              "offer": "Rs 299",
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Sunrise-Richer-Aroma-200g/dp/B01GCFA96Q/",
              "page_count": 48,
              "reviews": 195,
              "ratings": 4.4,
              "image_count": 0,
              "product_name": "NESCAFÉ Sunrise Instant Coffee - Chicory Mixture, 200g Pouch",
              "item_id": "B01GCFA96Q",
              "brand": "nescafe"
            },
            {
              "order": 22,
              "price": "Rs 650",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Sunrise-Premium-Stabilo-500g/dp/B01C5IX1LO/",
              "page_count": 48,
              "reviews": 121,
              "ratings": 4.4,
              "image_count": 0,
              "product_name": "Nescafe Sunrise Rich Aroma, 500g",
              "item_id": "B01C5IX1LO",
              "brand": "nescafe"
            },
            {
              "order": 23,
              "price": "Rs 280",
              "offer": "Rs 340",
              "page": 1,
              "link": "https://www.amazon.in/Bru-Instant-Coffee-200g/dp/B01M29LD4Z/",
              "page_count": 48,
              "reviews": 293,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Bru Instant Coffee, 200g",
              "item_id": "B01M29LD4Z",
              "brand": "bru"
            },
            {
              "order": 24,
              "price": "Rs 490",
              "offer": "Rs 550",
              "page": 1,
              "link": "https://www.amazon.in/Supreme-World-Davidoff-Coffee-Espresso/dp/B0756X6PZZ/",
              "page_count": 48,
              "reviews": 164,
              "ratings": 4.5,
              "image_count": 1,
              "product_name": "Davidoff Cafe Espresso 57 Intense Instant Coffee Jar, 100 g",
              "item_id": "B0756X6PZZ",
              "brand": "davidoff"
            },
            {
              "order": 25,
              "price": null,
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Neuherbs-Organic-Coffee-Weight-Management/dp/B01LXFALAQ/",
              "page_count": 48,
              "reviews": 1260,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Neuherbs Green Coffee Beans Your Natural Immunity Booster And Weight Loss Partner: 400 G",
              "item_id": "B01LXFALAQ",
              "brand": "neuherbs"
            },
            {
              "order": 26,
              "price": "Rs 735",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Sunrise-Extra-Sachet-200g/dp/B01N4J4NOZ/",
              "page_count": 48,
              "reviews": 47,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Nescafe Sunrise Extra Sachet, 1kg (200g Pack of 5)",
              "item_id": "B01N4J4NOZ",
              "brand": "nescafe sunrise"
            },
            {
              "order": 27,
              "price": "Rs 479",
              "offer": "Rs 550",
              "page": 1,
              "link": "https://www.amazon.in/Davidoff-Coffee-Espresso-100g/dp/B004K76JFY/",
              "page_count": 48,
              "reviews": 1108,
              "ratings": 4.5,
              "image_count": 3,
              "product_name": "Davidoff Cafe Espresso 57 Intense Instant Coffee Jar, 100 g",
              "item_id": "B004K76JFY",
              "brand": "davidoff"
            },
            {
              "order": 28,
              "price": "Rs 420",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Blue-Tokai-Coffee-Roasters-Vienna/dp/B01C75MJPO/",
              "page_count": 48,
              "reviews": 301,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Blue Tokai Coffee Roasters Vienna Roast (Dark Roast) - 250 Gm (French Press)",
              "item_id": "B01C75MJPO",
              "brand": "blue tokai coffee roasters"
            },
            {
              "order": 29,
              "price": "Rs 331",
              "offer": "Rs 350",
              "page": 1,
              "link": "https://www.amazon.in/Lavazza-Crema-Ground-Coffee-Powder/dp/B00T41Y1NS/",
              "page_count": 48,
              "reviews": 99,
              "ratings": 4.2,
              "image_count": 5,
              "product_name": "Lavazza Crema E Gusto Ground Coffee Powder, 250g",
              "item_id": "B00T41Y1NS",
              "brand": "lavazza"
            },
            {
              "order": 30,
              "price": null,
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Neuherbs-Organic-Coffee-Powder-Management/dp/B01N7I1SXM/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Neuherbs Unroasted Green Coffee Beans Powder For Weight Loss: 400 G",
              "item_id": "B01N7I1SXM",
              "brand": "neuherbs"
            },
            {
              "order": 31,
              "price": "Rs 3,800",
              "offer": "Rs 5,999",
              "page": 1,
              "link": "https://www.amazon.in/Starbucks-Nespresso-Capsules-Favorites-Compatible/dp/B07Q6NF8DL/",
              "page_count": 48,
              "reviews": 431,
              "ratings": 4.7,
              "image_count": 7,
              "product_name": "Nespresso Starbucks Capsules, Favorites Variety Pack (50 Pods, Compatible with Nespresso Original Machines)",
              "item_id": "B07Q6NF8DL",
              "brand": "nespresso"
            },
            {
              "order": 32,
              "price": "Rs 1,480",
              "offer": "Rs 1,699",
              "page": 1,
              "link": "https://www.amazon.in/Starbucks-Colombia-Medium-Ground-Coffee/dp/B07RFD8YZJ/",
              "page_count": 48,
              "reviews": 33,
              "ratings": 3.9,
              "image_count": 1,
              "product_name": "Starbucks Colombia Medium Roast Ground Coffee Packet, 200g",
              "item_id": "B07RFD8YZJ",
              "brand": "starbucks"
            },
            {
              "order": 33,
              "price": "Rs 1,495",
              "offer": "Rs 1,650",
              "page": 1,
              "link": "https://www.amazon.in/Supreme-Davidoff-Espresso-Instant-Coffee/dp/B077FQ4KZ3/",
              "page_count": 48,
              "reviews": 25,
              "ratings": 4.5,
              "image_count": 1,
              "product_name": "Davidoff Cafe Rich Aroma, Fine Aroma and Espresso 57 Instant Coffee Combo - Combo Pack Jar, 3 x 100 g",
              "item_id": "B077FQ4KZ3",
              "brand": "davidoff"
            },
            {
              "order": 34,
              "price": "Rs 410",
              "offer": "Rs 420",
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Signature-Coffee-Vending-Machine/dp/B071GF7MNY/",
              "page_count": 48,
              "reviews": 62,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Nescafe Signature Blend Coffee Premix for Vending Machine, 1kg",
              "item_id": "B071GF7MNY",
              "brand": "nescafe"
            },
            {
              "order": 35,
              "price": "Rs 359",
              "offer": "Rs 399",
              "page": 1,
              "link": "https://www.amazon.in/Colombian-Brew-Pure-Instant-Coffee/dp/B06WD336JM/",
              "page_count": 48,
              "reviews": 360,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Colombian Brew Coffee Pure Instant Coffee Strong, 200g",
              "item_id": "B06WD336JM",
              "brand": "colombian brew coffee"
            },
            {
              "order": 36,
              "price": "Rs 479",
              "offer": "Rs 550",
              "page": 1,
              "link": "https://www.amazon.in/Davidoff-Fine-Aroma-100Gm/dp/B00N3VCKUG/",
              "page_count": 48,
              "reviews": 64,
              "ratings": 4.5,
              "image_count": 2,
              "product_name": "Davidoff Cafe Fine Aroma Grande Cuvee Instant Coffee Jar, 100 g",
              "item_id": "B00N3VCKUG",
              "brand": "davidoff"
            },
            {
              "order": 37,
              "price": "Rs 429",
              "offer": "Rs 480",
              "page": 1,
              "link": "https://www.amazon.in/iD-100-Authentic-Instant-Decoction/dp/B08D3RWHK4/",
              "page_count": 48,
              "reviews": 66,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "iD 100% Authentic Instant Filter Coffee Decoction - Pack of 40 , 800ml Coffee Liquid (20ml x 40)",
              "item_id": "B08D3RWHK4",
              "brand": "id 100% authentic"
            },
            {
              "order": 38,
              "price": null,
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Greenbrrew-Instant-Coffee-Weight-Management/dp/B01MG8M5BQ/",
              "page_count": 48,
              "reviews": 229,
              "ratings": 4,
              "image_count": 6,
              "product_name": "Greenbrrew Instant Green Coffee Premix for Weight Management (Natural, 20 Sachets), 3g Each - Easy to Use",
              "item_id": "B01MG8M5BQ",
              "brand": null
            },
            {
              "order": 39,
              "price": "Rs 969",
              "offer": "Rs 999",
              "page": 1,
              "link": "https://www.amazon.in/Colombian-Brew-Arabica-Filter-Coffee/dp/B06WRQS6LN/",
              "page_count": 48,
              "reviews": 112,
              "ratings": 4.1,
              "image_count": 5,
              "product_name": "Colombian Brew Coffeebica Espresso , Roast & Ground Strong, 1kg",
              "item_id": "B06WRQS6LN",
              "brand": "colombian brew coffee"
            },
            {
              "order": 40,
              "price": "Rs 632",
              "offer": "Rs 1,199",
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Gold-Decaf-Smooth-Coffee/dp/B08966JQGY/",
              "page_count": 48,
              "reviews": 7,
              "ratings": 4.5,
              "image_count": 6,
              "product_name": "Nescafe Gold Decaf Rich & Smooth Coffee,100g",
              "item_id": "B08966JQGY",
              "brand": "nescafe"
            },
            {
              "order": 41,
              "price": "Rs 1,578",
              "offer": "Rs 1,999",
              "page": 1,
              "link": "https://www.amazon.in/Davidoff-Espresso-Instant-Coffee-Bundle/dp/B01HOW4KB6/",
              "page_count": 48,
              "reviews": 189,
              "ratings": 4.6,
              "image_count": 1,
              "product_name": "Davidoff Cafe Rich Aroma, Fine Aroma and Espresso 57 Instant Coffee - Combo Pack Jar, 3 x 100 g",
              "item_id": "B01HOW4KB6",
              "brand": "davidoff"
            },
            {
              "order": 42,
              "price": "Rs 550",
              "offer": "Rs 799",
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Original-Soluble-Beverage-Sachets/dp/B00ZP86N44/",
              "page_count": 48,
              "reviews": 417,
              "ratings": 3.9,
              "image_count": 1,
              "product_name": "Nescafe 3 in 1 Original Soluble Coffee Beverage, 30 Sachets Bag",
              "item_id": "B00ZP86N44",
              "brand": "nescafe"
            },
            {
              "order": 43,
              "price": "Rs 599",
              "offer": "Rs 698",
              "page": 1,
              "link": "https://www.amazon.in/Rage-Coffee-Combo-Pack-Chocolate/dp/B08JSH7369/",
              "page_count": 48,
              "reviews": 5,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Rage Coffee Combo Pack of 2 - Irish Hazelnut & Dark Chocolate Flavoured Coffee 50 GMS Each",
              "item_id": "B08JSH7369",
              "brand": "rage coffee"
            },
            {
              "order": 44,
              "price": "Rs 299",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Nescafe-Sunrise-Premium-200-g/dp/B00VJYYJ80/",
              "page_count": 48,
              "reviews": 145,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Nescafe Rich Aroma Instant Coffee-Chicory Mix, 200g Pouch",
              "item_id": "B00VJYYJ80",
              "brand": "nescafe"
            },
            {
              "order": 45,
              "price": "Rs 240",
              "offer": "Rs 250",
              "page": 1,
              "link": "https://www.amazon.in/Sunbean-Beaten-Caffe-250-g/dp/B0813TSG2Q/",
              "page_count": 48,
              "reviews": 244,
              "ratings": 3.5,
              "image_count": 6,
              "product_name": "Sunbean Beaten Caffe, Instant Coffee Paste 250g Jar | Rich, Creamy and Frothy Beaten Coffee | Make Hot Coffee, Cappuccino or Cold Coffee",
              "item_id": "B0813TSG2Q",
              "brand": "sunbean"
            },
            {
              "order": 46,
              "price": null,
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in/Neuherbs%C2%AE-Instant-Coffee-Flavour-Management/dp/B07CNXG347/",
              "page_count": 48,
              "reviews": 449,
              "ratings": 4,
              "image_count": 6,
              "product_name": "Neuherbs Instant Green Coffee Premix for Weight Management: 30 Sachet",
              "item_id": "B07CNXG347",
              "brand": "neuherbs"
            },
            {
              "order": 47,
              "price": "Rs 186",
              "offer": "Rs 215",
              "page": 1,
              "link": "https://www.amazon.in/Pristine-Deccan-Gold-Premium-Filter/dp/B07DCT6PBN/",
              "page_count": 48,
              "reviews": 139,
              "ratings": 4.2,
              "image_count": 5,
              "product_name": "Pristine Deccan Gold - Premium Filter Coffee, 80:20 Blend, 500g",
              "item_id": "B07DCT6PBN",
              "brand": "pristine"
            },
            {
              "order": 48,
              "price": "Rs 285",
              "offer": "Rs 300",
              "page": 1,
              "link": "https://www.amazon.in/Seven-Beans-URUBAGE-Indian-Chicory/dp/B07XLRVTQP/",
              "page_count": 48,
              "reviews": 158,
              "ratings": 4,
              "image_count": 3,
              "product_name": "Seven Beans - URUBAGE South Indian Filter Coffee Powder - Coffee: 80%, Chicory: 20% ,500 g (Dark Roast)",
              "item_id": "B07XLRVTQP",
              "brand": "seven beans"
            },
            {
              "order": 49,
              "price": "Rs 299",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Nescafe-Sunrise-Premium-200-g/dp/B00VJYYJ80/",
              "page_count": 48,
              "reviews": 145,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Nescafe Rich Aroma Instant Coffee-Chicory Mix, 200g Pouch",
              "item_id": "B00VJYYJ80",
              "brand": "nescafe"
            },
            {
              "order": 50,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Sinew-Nutrition-Coffee-Weight-Management/dp/B01M4MH3US/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Sinew Nutrition Green Coffee Beans 800g + 200g FREE (250g x 4 PC) for Weight Management",
              "item_id": "B01M4MH3US",
              "brand": "sinew nutrition"
            },
            {
              "order": 51,
              "price": "Rs 1,099",
              "offer": "Rs 1,100",
              "page": 2,
              "link": "https://www.amazon.in/Davidoff-Espresso-Intense-Instant-Coffee/dp/B083T49PVQ/",
              "page_count": 48,
              "reviews": 9,
              "ratings": 4.2,
              "image_count": 1,
              "product_name": "Davidoff Cafe Espresso 57 Intense, Instant Coffee, 100g (2 Pack)",
              "item_id": "B083T49PVQ",
              "brand": "davidoff"
            },
            {
              "order": 52,
              "price": "Rs 549",
              "offer": "Rs 599",
              "page": 2,
              "link": "https://www.amazon.in/Rage-Coffee-Dark-Chocolate-Flavoured/dp/B082P21XDJ/",
              "page_count": 48,
              "reviews": 72,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Rage Coffee 100 GMS Dark Chocolate Flavoured Coffee - 100% Premium Arabica Instant Coffee",
              "item_id": "B082P21XDJ",
              "brand": "rage coffee"
            },
            {
              "order": 53,
              "price": "Rs 450",
              "offer": "Rs 460",
              "page": 2,
              "link": "https://www.amazon.in/Jayanthi-Coffee-Golden-Blend-85/dp/B07532SHZ3/",
              "page_count": 48,
              "reviews": 120,
              "ratings": 4.3,
              "image_count": 2,
              "product_name": "JAYANTHI Golden Blend, Coffee Contains 15% Chicory, fine or Nice Grind, 250g x 4",
              "item_id": "B07532SHZ3",
              "brand": "jayanthi"
            },
            {
              "order": 54,
              "price": "Rs 240",
              "offer": "Rs 250",
              "page": 2,
              "link": "https://www.amazon.in/Sunbean-Beaten-Caffe-250-g/dp/B0813TSG2Q/",
              "page_count": 48,
              "reviews": 244,
              "ratings": 3.5,
              "image_count": 6,
              "product_name": "Sunbean Beaten Caffe, Instant Coffee Paste 250g Jar | Rich, Creamy and Frothy Beaten Coffee | Make Hot Coffee, Cappuccino or Cold Coffee",
              "item_id": "B0813TSG2Q",
              "brand": "sunbean"
            },
            {
              "order": 55,
              "price": null,
              "offer": "Rs 1,199",
              "page": 2,
              "link": "https://www.amazon.in/Neuherbs-Organic-Green-Coffee-Weight/dp/B075HBNWR3/",
              "page_count": 48,
              "reviews": 70,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Neuherbs Green Coffee Beans powder For Weight Loss: 1.2 Kg",
              "item_id": "B075HBNWR3",
              "brand": "neuherbs"
            },
            {
              "order": 56,
              "price": "Rs 480",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Blue-Tokai-Coffee-Seethargundu-Biody/dp/B0834Q5M81/",
              "page_count": 48,
              "reviews": 15,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Blue Tokai Coffee Roasters Seethargundu Biody Light Roast Whole Beans Premium Coffee Powder (250 Gm)",
              "item_id": "B0834Q5M81",
              "brand": "blue tokai coffee roasters"
            },
            {
              "order": 57,
              "price": "Rs 849",
              "offer": "Rs 1,198",
              "page": 2,
              "link": "https://www.amazon.in/Rage-Coffee-Original-Premium-Arabica/dp/B082NBN9FJ/",
              "page_count": 48,
              "reviews": 30,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "Rage Coffee - 200 GMS Original Blend - Premium Arabica Instant Coffee",
              "item_id": "B082NBN9FJ",
              "brand": "rage coffee"
            },
            {
              "order": 58,
              "price": "Rs 540",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Sidapur-Filter-Coffee-Powder-Chicory/dp/B018RYOLMI/",
              "page_count": 48,
              "reviews": 224,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Sidapur Pure Filter Coffee - Roast & Ground (Powder) 100% Coffee, 0% Chicory - 500gms",
              "item_id": "B018RYOLMI",
              "brand": "sidapur"
            },
            {
              "order": 59,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Green-Coffee-Bean-Extract-Capsules/dp/B0748GQX3M/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.6,
              "image_count": 4,
              "product_name": "Wow Green Coffee Bean Extract Capsules - 60 Count",
              "item_id": "B0748GQX3M",
              "brand": "sidapur"
            },
            {
              "order": 60,
              "price": "Rs 515",
              "offer": "Rs 750",
              "page": 2,
              "link": "https://www.amazon.in/Nescafe-Gold-200-gr-Oz/dp/B0034D5DE8/",
              "page_count": 48,
              "reviews": 260,
              "ratings": 4.4,
              "image_count": 5,
              "product_name": "Nescafe Gold (200 g, 7 oz)",
              "item_id": "B0034D5DE8",
              "brand": "nescafe"
            },
            {
              "order": 61,
              "price": "Rs 190",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Colombian-Brew-Coffee-Hazelnut-Instant/dp/B07P5Z34R6/",
              "page_count": 48,
              "reviews": 232,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Colombian Brew Coffee Hazelnut Instant Coffee, No Sugar Vegan, 50gm",
              "item_id": "B07P5Z34R6",
              "brand": "colombian brew coffee"
            },
            {
              "order": 62,
              "price": "Rs 709",
              "offer": "Rs 750",
              "page": 2,
              "link": "https://www.amazon.in/Lavazza-Italys-Favourite-Premium-Arabica/dp/B0069K3GHE/",
              "page_count": 48,
              "reviews": 75,
              "ratings": 4.3,
              "image_count": 3,
              "product_name": "Lavazza Club Italy's Favourite Ground Coffee, 100% Premium Arabica, 250g",
              "item_id": "B0069K3GHE",
              "brand": "lavazza"
            },
            {
              "order": 63,
              "price": "Rs 999",
              "offer": "Rs 1,300",
              "page": 2,
              "link": "https://www.amazon.in/Country-Bean-Instant-Hazelnut-Flavours/dp/B08FD9CB44/",
              "page_count": 48,
              "reviews": 62,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "Country Bean Instant Coffee Powder with Hazelnut, Caramel, Vanilla and Cocoa Mint Flavours, 60 gm Each - Combo Pack 4",
              "item_id": "B08FD9CB44",
              "brand": "country bean"
            },
            {
              "order": 64,
              "price": "Rs 700",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Coffee-Day-Roasted-Beans-1kg/dp/B07HRB8LCP/",
              "page_count": 48,
              "reviews": 146,
              "ratings": 4,
              "image_count": 7,
              "product_name": "Coffee Day Roasted Coffee Beans, 1kg",
              "item_id": "B07HRB8LCP",
              "brand": "coffee day"
            },
            {
              "order": 65,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Neuherbs-Green-Coffee-weight-Management/dp/B01CIHBACY/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4,
              "image_count": 6,
              "product_name": "Neuherbs Green Coffee Beans For Immunity Booster and Weight Loss Partner: 800 G",
              "item_id": "B01CIHBACY",
              "brand": "neuherbs"
            },
            {
              "order": 66,
              "price": "Rs 1,085",
              "offer": "Rs 1,100",
              "page": 2,
              "link": "https://www.amazon.in/Davidoff-Espresso-Instant-Coffee-Bottle/dp/B084G33S71/",
              "page_count": 48,
              "reviews": 3,
              "ratings": 4.9,
              "image_count": 1,
              "product_name": "Davidoff Fine Aroma & Espresso 57 Instant Coffee Bottle, 2 X 100 g",
              "item_id": "B084G33S71",
              "brand": "davidoff"
            },
            {
              "order": 67,
              "price": "Rs 750",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Davidoff-Limited-Topaz-Bottle-100/dp/B084G2F94X/",
              "page_count": 48,
              "reviews": 54,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "Davidoff Limited Edition - Topaz Bottle, 100 g",
              "item_id": "B084G2F94X",
              "brand": "davidoff"
            },
            {
              "order": 68,
              "price": "Rs 1,090",
              "offer": "Rs 1,100",
              "page": 2,
              "link": "https://www.amazon.in/Davidoff-Coffee-Rich-Aroma-Espresso/dp/B07C233F4P/",
              "page_count": 48,
              "reviews": 30,
              "ratings": 4.6,
              "image_count": 1,
              "product_name": "Davidoff Cafe Rich Aroma and Espresso 57 Instant Coffee - Combo Pack Jar, 2 x 100 g",
              "item_id": "B07C233F4P",
              "brand": "davidoff"
            },
            {
              "order": 69,
              "price": "Rs 504",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Narasus-Coffee-Pure-Filter-Peabery/dp/B01KHITD7A/",
              "page_count": 48,
              "reviews": 49,
              "ratings": 4.3,
              "image_count": 3,
              "product_name": "Narasus Coffee Pure Filter Coffee, Peabery - 2 X 500Gms",
              "item_id": "B01KHITD7A",
              "brand": "narasus coffee"
            },
            {
              "order": 70,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/iD-100-Authentic-1200ml-Filter/dp/B08M5WDJ78/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 5,
              "product_name": "iD 100% Authentic 60 Cups 1200ml Fresh Filter Coffee Liquid (150ml x 8) - Pack of 8",
              "item_id": "B08M5WDJ78",
              "brand": "id 100% authentic"
            },
            {
              "order": 71,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/GreenicheTM-Chlorogenic-Antioxidant-Supplement-Metabolism/dp/B07L32CNR2/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.6,
              "image_count": 7,
              "product_name": "Greeniche Green Coffee Bean Extract 800 mg for Weight Loss - 90 Veg Capsules",
              "item_id": "B07L32CNR2",
              "brand": "greeniche"
            },
            {
              "order": 72,
              "price": "Rs 515",
              "offer": "Rs 750",
              "page": 2,
              "link": "https://www.amazon.in/Nescafe-Blend-Instant-Coffee-Powder/dp/B00MNAGUGS/",
              "page_count": 48,
              "reviews": 204,
              "ratings": 4.3,
              "image_count": 4,
              "product_name": "Nescafe Gold Blend Instant Coffee Powder, 200g Eden Jar",
              "item_id": "B00MNAGUGS",
              "brand": "nescafe"
            },
            {
              "order": 73,
              "price": "Rs 229",
              "offer": "Rs 299",
              "page": 2,
              "link": "https://www.amazon.in/Colombian-Brew-Arabica-Filter-Coffee/dp/B06VV27WVF/",
              "page_count": 48,
              "reviews": 575,
              "ratings": 3.8,
              "image_count": 7,
              "product_name": "Colombian Brew Coffee Arabica Espresso Filter Coffee, Roast & Ground Strong, 250g",
              "item_id": "B06VV27WVF",
              "brand": "colombian brew coffee"
            },
            {
              "order": 74,
              "price": "Rs 499",
              "offer": "Rs 599",
              "page": 2,
              "link": "https://www.amazon.in/Rage-Coffee-Ethiopian-Crystals-Vitamins/dp/B07NS2FZJX/",
              "page_count": 48,
              "reviews": 277,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Rage Coffee - Premium 100% Ethiopian Arabica Instant Coffee Crystals Infused with Natural Vitamins - 100 GMS | Award Winning Healthy Blend",
              "item_id": "B07NS2FZJX",
              "brand": "rage coffee"
            },
            {
              "order": 75,
              "price": "Rs 480",
              "offer": "Rs 570",
              "page": 2,
              "link": "https://www.amazon.in/iD-100-Authentic-Filter-Coffee/dp/B08M6546MR/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 5,
              "image_count": 5,
              "product_name": "iD 100% Authentic 45 Cups Fresh Filter Coffee Liquid (150ml x 6 -900ml) - Pack of 6",
              "item_id": "B08M6546MR",
              "brand": "id 100% authentic"
            },
            {
              "order": 76,
              "price": "Rs 560",
              "offer": "Rs 800",
              "page": 2,
              "link": "https://www.amazon.in/My-Tyche-Mocha-Mild-Coffee/dp/B082B4Z2SP/",
              "page_count": 48,
              "reviews": 5,
              "ratings": 3.3,
              "image_count": 2,
              "product_name": "My Tyche Mocha Mild Coffee, 3 In1 Coffee Sugar Milk Powder, Korean Taste, Mocha Mild Coffee, Set of 50 Sticks",
              "item_id": "B082B4Z2SP",
              "brand": "generic"
            },
            {
              "order": 77,
              "price": "Rs 220",
              "offer": "Rs 240",
              "page": 2,
              "link": "https://www.amazon.in/Cothas-Coffee-500g/dp/B073QW91PD/",
              "page_count": 48,
              "reviews": 45,
              "ratings": 4.6,
              "image_count": 3,
              "product_name": "Cothas Coffee, 500g",
              "item_id": "B073QW91PD",
              "brand": "cothas"
            },
            {
              "order": 78,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Coffee-Bean-Direct-Italian-Espresso/dp/B002GWFA1Y/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.5,
              "image_count": 4,
              "product_name": "Coffee Bean Direct Italian Roast Espresso, Whole Bean Coffee, 5-Pound Bag",
              "item_id": "B002GWFA1Y",
              "brand": "coffee bean direct"
            },
            {
              "order": 79,
              "price": "Rs 599",
              "offer": "Rs 699",
              "page": 2,
              "link": "https://www.amazon.in/Chefsneed-Nescafe-Coffee-Beverage-Sachets/dp/B07HRWWG5C/",
              "page_count": 48,
              "reviews": 34,
              "ratings": 4.1,
              "image_count": 3,
              "product_name": "Chefsneed Nescafe 3 in 1 Coffee Beverage -30 Sachets",
              "item_id": "B07HRWWG5C",
              "brand": "chefsneed"
            },
            {
              "order": 80,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Ariginallo-Premium-Organic-Coffee-Weight/dp/B07FMZ6KBH/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.8,
              "image_count": 7,
              "product_name": "Ariginallo Green Coffee Beans for Weight Loss 350 G",
              "item_id": "B07FMZ6KBH",
              "brand": "ariginallo"
            },
            {
              "order": 81,
              "price": "Rs 880",
              "offer": "Rs 1,000",
              "page": 2,
              "link": "https://www.amazon.in/Davidoff-Explorers-Choice-Premium-Masterly/dp/B08F65NF4L/",
              "page_count": 48,
              "reviews": 18,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Davidoff Explorer's Choice - Premium Label - Masterly Blended Instant Coffee 100g",
              "item_id": "B08F65NF4L",
              "brand": "davidoff"
            },
            {
              "order": 82,
              "price": "Rs 709",
              "offer": "Rs 750",
              "page": 2,
              "link": "https://www.amazon.in/Lavazza-Qualita-Oro-Perfect-Symphony/dp/B0069K3JC6/",
              "page_count": 48,
              "reviews": 24,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Lavazza Qualita Oro, Perfect Symphony, 250 g",
              "item_id": "B0069K3JC6",
              "brand": "lavazza"
            },
            {
              "order": 83,
              "price": "Rs 650",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Coffee-Brewing-Company-Assorted-Flavors/dp/B07XRPV1VF/",
              "page_count": 48,
              "reviews": 11,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "The Coffee Brewing Co. The First Brew Kit / Gift Box (Combo of 4)",
              "item_id": "B07XRPV1VF",
              "brand": "the coffee brewing company"
            },
            {
              "order": 84,
              "price": "Rs 570",
              "offer": "Rs 600",
              "page": 2,
              "link": "https://www.amazon.in/Lavazza-Relish-Cherish-Family-Mattino/dp/B08DRMYBQK/",
              "page_count": 48,
              "reviews": 33,
              "ratings": 4.1,
              "image_count": 5,
              "product_name": "Lavazza Relish & Cherish Family Edition, 4 X 200 g with Il Mattino Vivace, Filter Coffee & Free Mug",
              "item_id": "B08DRMYBQK",
              "brand": "lavazza"
            },
            {
              "order": 85,
              "price": "Rs 500",
              "offer": "Rs 630",
              "page": 2,
              "link": "https://www.amazon.in/Davidoff-464388-Espresso-Coffee-100g/dp/B00C66DMSS/",
              "page_count": 48,
              "reviews": 152,
              "ratings": 4.5,
              "image_count": 1,
              "product_name": "Davidoff Cafe Intense Instant Coffee - Espresso 57, 100g Jar",
              "item_id": "B00C66DMSS",
              "brand": "davidoff"
            },
            {
              "order": 86,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Nutrition-Coffee-Powder-Weight-Management/dp/B0851FGQX2/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.7,
              "image_count": 7,
              "product_name": "Sinew Nutrition Green Coffee Beans Powder for Weight Management - 200 g (Pack of 2)",
              "item_id": "B0851FGQX2",
              "brand": null
            },
            {
              "order": 87,
              "price": "Rs 599",
              "offer": "Rs 700",
              "page": 2,
              "link": "https://www.amazon.in/Wnature-Organic-Roasted-1kg-100-Natural/dp/B07PYT8YLG/",
              "page_count": 48,
              "reviews": 197,
              "ratings": 3.9,
              "image_count": 3,
              "product_name": "Wnature Organic Roasted Coffee Beans 1 Kg - 100% Pure N Natural",
              "item_id": "B07PYT8YLG",
              "brand": "wnature"
            },
            {
              "order": 88,
              "price": "Rs 499",
              "offer": "Rs 599",
              "page": 2,
              "link": "https://www.amazon.in/Jarved-Hustlers-Coffee-Arabica-Instant/dp/B08BTXLPYD/",
              "page_count": 48,
              "reviews": 84,
              "ratings": 4.6,
              "image_count": 6,
              "product_name": "Jarved Hustler's Edit Coffee- Arabica Instant Coffee | 150g",
              "item_id": "B08BTXLPYD",
              "brand": "jarved"
            },
            {
              "order": 89,
              "price": "Rs 1,199",
              "offer": "Rs 1,396",
              "page": 2,
              "link": "https://www.amazon.in/Rage-Coffee-Combo-Pack-Chocolate/dp/B08DG6XL7B/",
              "page_count": 48,
              "reviews": 56,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "Rage Coffee Combo Pack of 4 - Irish Hazelnut & Dark Chocolate & Creme Caramel & Sparky Orange Flavoured Coffee 50 GMS Each",
              "item_id": "B08DG6XL7B",
              "brand": "rage coffee"
            },
            {
              "order": 90,
              "price": null,
              "offer": "Rs 1,299",
              "page": 2,
              "link": "https://www.amazon.in/Neuherbs-green-coffee-Beans-Weight/dp/B07PTQM1MX/",
              "page_count": 48,
              "reviews": 46,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Neuherbs Green Coffee Beans For Natural Immunity Booster And Your Weight Loss Partner: 1.5 Kg",
              "item_id": "B07PTQM1MX",
              "brand": "neuherbs"
            },
            {
              "order": 91,
              "price": "Rs 247",
              "offer": "Rs 275",
              "page": 2,
              "link": "https://www.amazon.in/Bru-Gold-Instant-Coffee-100g/dp/B01GCFCZLI/",
              "page_count": 48,
              "reviews": 197,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Bru Gold Instant Coffee, 100% Pure Granulated Coffee, 100 g",
              "item_id": "B01GCFCZLI",
              "brand": "bru"
            },
            {
              "order": 92,
              "price": "Rs 475",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Sidapur-Indian-Filter-Roasted-Chicory/dp/B076CGBYZ5/",
              "page_count": 48,
              "reviews": 159,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Sidapur - South Indian Filter Coffee - Roasted and Ground - Coffee 80% : Chicory 20% - 500gms",
              "item_id": "B076CGBYZ5",
              "brand": "sidapur"
            },
            {
              "order": 93,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Speaking-Tree-Exfoliating-Refreshing-Brightening/dp/B083Q33CH5/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.9,
              "image_count": 6,
              "product_name": "Speaking Tree Exfoliating Coffee Handmade Soap with Refreshing Aroma for Perfectly Clean, Brightening Skin (Pack of 3)",
              "item_id": "B083Q33CH5",
              "brand": null
            },
            {
              "order": 94,
              "price": "Rs 380",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in/Colombian-Brew-Coffee-Chocolate-Blueberry/dp/B07P99VWQC/",
              "page_count": 48,
              "reviews": 164,
              "ratings": 3.9,
              "image_count": 5,
              "product_name": "Colombian Brew Coffee Double Chocolate Mocha 50g, Mint Chocolate Mocha 50g, Blueberry Chocolate Mocha 50g, Buy 2 Get 1 Free",
              "item_id": "B07P99VWQC",
              "brand": "colombian brew coffee"
            },
            {
              "order": 95,
              "price": "Rs 1,480",
              "offer": "Rs 1,699",
              "page": 2,
              "link": "https://www.amazon.in/Starbucks-House-Medium-Ground-Coffee/dp/B07QK98Z8M/",
              "page_count": 48,
              "reviews": 24,
              "ratings": 3.6,
              "image_count": 1,
              "product_name": "Starbucks House Blend Medium Roast Ground Coffee, 200g",
              "item_id": "B07QK98Z8M",
              "brand": "starbucks"
            },
            {
              "order": 96,
              "price": "Rs 561",
              "offer": "Rs 598",
              "page": 2,
              "link": "https://www.amazon.in/Colombian-Brew-Coffee-Arabica-French/dp/B07QBPV9QX/",
              "page_count": 48,
              "reviews": 13,
              "ratings": 3.9,
              "image_count": 2,
              "product_name": "Colombian Brew Coffee Colombian Brew Arabica French Press Coffee 250gm, Buy 2 Get 1 Free, 750 g",
              "item_id": "B07QBPV9QX",
              "brand": "colombian brew coffee"
            },
            {
              "order": 97,
              "price": "Rs 380",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Colombian-Brew-Coffee-Chocolate-Blueberry/dp/B07P99VWQC/",
              "page_count": 48,
              "reviews": 164,
              "ratings": 3.9,
              "image_count": 5,
              "product_name": "Colombian Brew Coffee Double Chocolate Mocha 50g, Mint Chocolate Mocha 50g, Blueberry Chocolate Mocha 50g, Buy 2 Get 1 Free",
              "item_id": "B07P99VWQC",
              "brand": "colombian brew coffee"
            },
            {
              "order": 98,
              "price": "Rs 500",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Continental-Instant-Hazelnut-Cappuccino-Caramel/dp/B07ZGY69KJ/",
              "page_count": 48,
              "reviews": 51,
              "ratings": 4,
              "image_count": 7,
              "product_name": "Continental THIS 3 in 1 Premix Instant Coffee Combo (Creamy 18g + Hazelnut 22g + Cappuccino 22g + Caramel 22g + Mocha 22g) ( Gift / Festive Pack )",
              "item_id": "B07ZGY69KJ",
              "brand": "continental this"
            },
            {
              "order": 99,
              "price": "Rs 150",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Nestl%C3%A9-India-Limited-Nescaf%C3%A9-Cappuccino/dp/B07P218VH6/",
              "page_count": 48,
              "reviews": 48,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Nestle India Limited Nescafe Gold Cappuccino, 5 sachets x 25g, 125 g",
              "item_id": "B07P218VH6",
              "brand": "nestle india limited"
            },
            {
              "order": 100,
              "price": "Rs 360",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Colombian-Brew-Coffee-Instant-Sachets/dp/B07QHMPHNK/",
              "page_count": 48,
              "reviews": 138,
              "ratings": 3.9,
              "image_count": 4,
              "product_name": "Colombian Brew Coffee Pure Instant Coffee Sachets, Pack of 180",
              "item_id": "B07QHMPHNK",
              "brand": "colombian brew coffee"
            },
            {
              "order": 101,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Saffola-Fittify-Gourmet-Instant-Beverage/dp/B07KSQV55V/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Saffola FITTIFY Gourmet Green Coffee Instant Beverage Mix for Weight Management - 30g (Classic, 15 Sachets)",
              "item_id": null,
              "brand": null
            },
            {
              "order": 102,
              "price": "Rs 550",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/G7-Instant-Coffee-3-Servings/dp/B008A0AL0G/",
              "page_count": 48,
              "reviews": 130,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "G&G G7 Instant 3-in-1, 20 Servings",
              "item_id": "B008A0AL0G",
              "brand": "g&g"
            },
            {
              "order": 103,
              "price": "Rs 59",
              "offer": "Rs 90",
              "page": 3,
              "link": "https://www.amazon.in/Bru-Instant-Coffee-Pouch-50/dp/B01FS8JJTG/",
              "page_count": 48,
              "reviews": 19,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Bru Instant Coffee Pouch 50 g",
              "item_id": "B01FS8JJTG",
              "brand": "bru"
            },
            {
              "order": 104,
              "price": "Rs 599",
              "offer": "Rs 650",
              "page": 3,
              "link": "https://www.amazon.in/Country-Bean-Instant-Hazelnut-Flavours/dp/B07C5Z6N24/",
              "page_count": 48,
              "reviews": 477,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Country Bean Instant Coffee Powder with Hazelnut and Caramel Flavours, 60g - Pack of 2",
              "item_id": "B07C5Z6N24",
              "brand": "country bean"
            },
            {
              "order": 105,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/MCaffeine-Coffee-Coconut-Removal-Paraben/dp/B07K4BFQK1/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "mCaffeine Naked & Raw Coffee Body Scrub, 100 g | Coconut | Tan Removal | Oily/Normal Skin | Paraben & SLS Free",
              "item_id": null,
              "brand": null
            },
            {
              "order": 106,
              "price": "Rs 4,495",
              "offer": "Rs 9,999",
              "page": 3,
              "link": "https://www.amazon.in/Nespresso-Variety-Pack-Capsules-Count/dp/B0099HD3YA/",
              "page_count": 48,
              "reviews": 4540,
              "ratings": 4.7,
              "image_count": 6,
              "product_name": "Nespresso Variety Pack Capsules, 50 Count",
              "item_id": "B0099HD3YA",
              "brand": "nespresso"
            },
            {
              "order": 107,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Starbucks-Nespresso-Espresso-Coffee-Capsules/dp/B07W5YMCHV/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 5,
              "product_name": "Starbucks by Nespresso Espresso Roast Coffee Pods 10 Capsules",
              "item_id": null,
              "brand": null
            },
            {
              "order": 108,
              "price": "Rs 549",
              "offer": "Rs 599",
              "page": 3,
              "link": "https://www.amazon.in/Rage-Coffee-Irish-Hazelnut-Flavoured/dp/B082P2Y4JV/",
              "page_count": 48,
              "reviews": 114,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Rage Coffee 100 GMS Irish Hazelnut Flavoured Coffee - 100% Premium Arabica Instant Coffee",
              "item_id": "B082P2Y4JV",
              "brand": "rage coffee"
            },
            {
              "order": 109,
              "price": "Rs 499",
              "offer": "Rs 599",
              "page": 3,
              "link": "https://www.amazon.in/Jarved-Columbian-Arabica-Instant-Coffee/dp/B084R5MJLM/",
              "page_count": 48,
              "reviews": 197,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Jarved Columbian Arabica Instant Coffee: 150g |Makes 75 cups| 100% Agglomerated Freeze Dried Coffee | Premium Tin Box",
              "item_id": "B084R5MJLM",
              "brand": "jarved"
            },
            {
              "order": 110,
              "price": "Rs 599",
              "offer": "Rs 698",
              "page": 3,
              "link": "https://www.amazon.in/Rage-Coffee-Combo-Pack-Flavoured/dp/B08DG6D97D/",
              "page_count": 48,
              "reviews": 37,
              "ratings": 4,
              "image_count": 6,
              "product_name": "Rage Coffee Combo Pack of 2 - Irish Hazelnut & Creme Caramel Flavoured Coffee 50 GMS Each",
              "item_id": "B08DG6D97D",
              "brand": "rage coffee"
            },
            {
              "order": 111,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Greenbrrew-Strong-Coffee-Management-Sachets/dp/B074G59F3Q/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Greenbrrew Green Coffee For Weight Loss (Strong Flavor) 20'S Sachets - (60G X Pack Of 2)",
              "item_id": null,
              "brand": null
            },
            {
              "order": 112,
              "price": "Rs 653",
              "offer": "Rs 800",
              "page": 3,
              "link": "https://www.amazon.in/Lavazza-Caffe-Espresso-Beans-250/dp/B0084CP69G/",
              "page_count": 48,
              "reviews": 26,
              "ratings": 4,
              "image_count": 7,
              "product_name": "Lavazza Caffe Espresso Beans, 250 g",
              "item_id": "B0084CP69G",
              "brand": "lavazza"
            },
            {
              "order": 113,
              "price": "Rs 420",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Blue-Tokai-Coffee-Roasters-Attikan/dp/B00N500WC8/",
              "page_count": 48,
              "reviews": 185,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Blue Tokai Coffee Roasters Attikan Estate -Medium Dark Roast- French Press (250 Gm)",
              "item_id": "B00N500WC8",
              "brand": "blue tokai coffee roasters"
            },
            {
              "order": 114,
              "price": "Rs 299",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Colombian-Brew-Coffee-Assorted-Hazelnut/dp/B07ZGNPFKX/",
              "page_count": 48,
              "reviews": 61,
              "ratings": 4,
              "image_count": 5,
              "product_name": "Colombian Brew Coffee Assorted Instant Coffee Box (Strong,Vanilla,Hazelnut,Cinnamon), 80g",
              "item_id": "B07ZGNPFKX",
              "brand": "colombian brew coffee"
            },
            {
              "order": 115,
              "price": "Rs 320",
              "offer": "Rs 380",
              "page": 3,
              "link": "https://www.amazon.in/iD-100-Authentic-Instant-Filter/dp/B08B1JLXW9/",
              "page_count": 48,
              "reviews": 81,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "iD 100% Authentic Ready to Use, Instant Filter Coffee Decoction 30 Cups | 600ml Coffee Liquid (150ml x 4) | Add Hot Milk and Sugar to Taste",
              "item_id": "B08B1JLXW9",
              "brand": "id 100% authentic"
            },
            {
              "order": 116,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Neuherbs-Organic-Green-Coffee-Management/dp/B06XT451ZN/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.8,
              "image_count": 6,
              "product_name": "Neuherbs Green Coffee Beans powder For Weight Loss: 800 G",
              "item_id": null,
              "brand": "neuherbs"
            },
            {
              "order": 117,
              "price": "Rs 475",
              "offer": "Rs 495",
              "page": 3,
              "link": "https://www.amazon.in/Beanies-Instant-Coffee-Nutty-Hazelnut/dp/B01JL0WYGC/",
              "page_count": 48,
              "reviews": 72,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Beanies The Flavour Co Flavoured Instant - Nutty Hazelnut, 50g",
              "item_id": "B01JL0WYGC",
              "brand": "beanies the flavour co"
            },
            {
              "order": 118,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Sinew-Nutrition-Coffee-Weight-Management/dp/B01LF7Y0S4/",
              "page_count": 48,
              "reviews": null,
              "ratings": 401,
              "image_count": 6,
              "product_name": "Sinew Nutrition Green Coffee Beans for Weight Management - 200 g + 50 g Free",
              "item_id": null,
              "brand": "sinew nutrition"
            },
            {
              "order": 119,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Amzn-Regular-Coffee-Vending-Machine/dp/B084HG3V6V/",
              "page_count": 48,
              "reviews": 21,
              "ratings": 3.3,
              "image_count": 6,
              "product_name": "Amzn Regular Coffee Premix Powder 1 Kg Pack for Vending Machine",
              "item_id": "B084HG3V6V",
              "brand": "amzn"
            },
            {
              "order": 120,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Lavazza-Caffe-Espresso-250-g/dp/B00Q2M35UM/",
              "page_count": 48,
              "reviews": 44,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Lavazza Caffe Espresso, 250 g",
              "item_id": "B00Q2M35UM",
              "brand": "lavazza"
            },
            {
              "order": 121,
              "price": "Rs 400",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Continental-Creamy-Premix-Instant-Sachets/dp/B08DM1Q8R2/",
              "page_count": 48,
              "reviews": 303,
              "ratings": 3.8,
              "image_count": 7,
              "product_name": "Continental THIS Creamy 3 in 1 Premix Instant Coffee 720g (18g*40 Sachets)",
              "item_id": "B08DM1Q8R2",
              "brand": "continental this"
            },
            {
              "order": 122,
              "price": "Rs 479",
              "offer": "Rs 490",
              "page": 3,
              "link": "https://www.amazon.in/Hathmic-Freeze-Dried-Instant-Coffee/dp/B07WNHT4XX/",
              "page_count": 48,
              "reviews": 92,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Hathmic Gold Freeze Dried Instant Coffee, 250 GMS",
              "item_id": "B07WNHT4XX",
              "brand": "hathmic"
            },
            {
              "order": 123,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Sinew-Nutrition-Coffee-Weight-Management/dp/B01M704G9R/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Sinew Nutrition Green Coffee Beans for Weight Management - 400 g + 100 g Free (250 g x 2 Piece)",
              "item_id": null,
              "brand": "sinew nutrition"
            },
            {
              "order": 124,
              "price": "Rs 560",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Devans-Arabica-French-Roast-Powder/dp/B07QQ9NZBZ/",
              "page_count": 48,
              "reviews": 30,
              "ratings": 4.2,
              "image_count": 4,
              "product_name": "Devan's Arabica French Roast Powder - 500 GMS",
              "item_id": "B07QQ9NZBZ",
              "brand": "devan's"
            },
            {
              "order": 125,
              "price": "Rs 799",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Alicafe-Classic-Instant-Coffee-Premix/dp/B07BXP2NLP/",
              "page_count": 48,
              "reviews": 22,
              "ratings": 4.3,
              "image_count": 4,
              "product_name": "Alicafe Classic Coffee- Instant Coffee 3 in 1 (Coffee Premix) – 400gm (20gm sachets X 20)",
              "item_id": "B07BXP2NLP",
              "brand": "alicafe"
            },
            {
              "order": 126,
              "price": "Rs 489",
              "offer": "Rs 495",
              "page": 3,
              "link": "https://www.amazon.in/Beanies-Instant-Coffee-Vanilla-50g/dp/B00LTN9JJU/",
              "page_count": 48,
              "reviews": 10,
              "ratings": 3.9,
              "image_count": 7,
              "product_name": "Beanies The Flavour Co Flavour Instant - Very Vanilla, 50g",
              "item_id": "B00LTN9JJU",
              "brand": "beanies the flavour co"
            },
            {
              "order": 127,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Wellona-Green-Coffee-Extract-Weight/dp/B075M4YK8D/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.6,
              "image_count": 7,
              "product_name": "Wellona Green Coffee Bean Extract Capsules for Ultra Weight Loss Supplement - 60 Tablet",
              "item_id": null,
              "brand": null
            },
            {
              "order": 128,
              "price": "Rs 700",
              "offer": "Rs 999",
              "page": 3,
              "link": "https://www.amazon.in/Nescafe-Gold-Blend-Decaf-100g/dp/B008PCJ3ZS/",
              "page_count": 48,
              "reviews": 87,
              "ratings": 4.2,
              "image_count": 5,
              "product_name": "Nescafe Gold Blend Decaff, 100g",
              "item_id": "B008PCJ3ZS",
              "brand": "nescafe gold"
            },
            {
              "order": 129,
              "price": "Rs 270",
              "offer": "Rs 699",
              "page": 3,
              "link": "https://www.amazon.in/Nescaf%C3%A9-Instant-Sublimated-Coffee-Bottle/dp/B0845DCGGQ/",
              "page_count": 48,
              "reviews": 9,
              "ratings": 4.7,
              "image_count": 1,
              "product_name": "Nescafe Gold Instant Sublimated Coffee in Glass Jar Bottle, 95 g",
              "item_id": "B0845DCGGQ",
              "brand": "nescafe"
            },
            {
              "order": 130,
              "price": "Rs 570",
              "offer": "Rs 650",
              "page": 3,
              "link": "https://www.amazon.in/Octavius-Instant-Coffee-Premix-Economy/dp/B07RZRP3FX/",
              "page_count": 48,
              "reviews": 65,
              "ratings": 3.7,
              "image_count": 5,
              "product_name": "Octavius Instant Coffee Premix Economy Pack - 50 Sachets",
              "item_id": "B07RZRP3FX",
              "brand": "octavius"
            },
            {
              "order": 131,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Sinew-Nutrition-Coffee-Weight-Management/dp/B01LF7Y2ZK/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.9,
              "image_count": 4,
              "product_name": "Sinew Nutrition Green Coffee Beans 400gm for Weight Management",
              "item_id": null,
              "brand": "sinew nutrition"
            },
            {
              "order": 132,
              "price": "Rs 905",
              "offer": "Rs 1,400",
              "page": 3,
              "link": "https://www.amazon.in/Starbucks-Blonde-Espresso-Roast-Whole/dp/B07P9RGGS3/",
              "page_count": 48,
              "reviews": 13,
              "ratings": 4.5,
              "image_count": 5,
              "product_name": "Starbucks Blonde Espresso Roast Whole Bean, 200g",
              "item_id": "B07P9RGGS3",
              "brand": "starbucks"
            },
            {
              "order": 133,
              "price": "Rs 250",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Bayars-Coffee-80-Degree-Grams/dp/B014668KQ4/",
              "page_count": 48,
              "reviews": 209,
              "ratings": 4.3,
              "image_count": 3,
              "product_name": "Bayars Coffee 80 Degree Coffee - 500 Grams",
              "item_id": "B014668KQ4",
              "brand": "bayars coffee"
            },
            {
              "order": 134,
              "price": null,
              "offer": "Rs 150",
              "page": 3,
              "link": "https://www.amazon.in/Nescaf%C3%A9-Classic-Coffee-50g-Sachet/dp/B00TIK8956/",
              "page_count": 48,
              "reviews": 159,
              "ratings": 4.5,
              "image_count": 1,
              "product_name": "Nescafe Classic Coffee, 50g Pouch",
              "item_id": "B00TIK8956",
              "brand": "nescafe"
            },
            {
              "order": 135,
              "price": "Rs 319",
              "offer": "Rs 325",
              "page": 3,
              "link": "https://www.amazon.in/Country-Bean-Caramel-Flavoured-Instant/dp/B07C631Y22/",
              "page_count": 48,
              "reviews": 374,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Country Bean Instant Coffee Powder | Caramel Flavoured Coffee 60 g",
              "item_id": "B07C631Y22",
              "brand": "country bean"
            },
            {
              "order": 136,
              "price": "Rs 420",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Blue-Tokai-Coffee-Roasters-French/dp/B077N5Y98F/",
              "page_count": 48,
              "reviews": 124,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Blue Tokai Coffee Roasters French Roast (Dark Roast) - 250 Gm (French Press)",
              "item_id": "B077N5Y98F",
              "brand": "blue tokai coffee roasters"
            },
            {
              "order": 137,
              "price": "Rs 299",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Nescafe-Sunrise-Premium-Coffee-Pouch/dp/B0096QXUX8/",
              "page_count": 48,
              "reviews": 88,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Nescafe Sunrise, Instant Coffee-Chicory Mix, 200g Pouch",
              "item_id": "B0096QXUX8",
              "brand": "nescafe"
            },
            {
              "order": 138,
              "price": "Rs 250",
              "offer": "Rs 299",
              "page": 3,
              "link": "https://www.amazon.in/Nescafe-Classic-Coffee-100-g/dp/B07HZ42GLQ/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 3.8,
              "image_count": 4,
              "product_name": "Nescafe Classic Coffee, 100 g",
              "item_id": "B07HZ42GLQ",
              "brand": "nescafe"
            },
            {
              "order": 139,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Sinew-Nutrition-Coffee-Powder-Management/dp/B07DPTNBB6/",
              "page_count": 48,
              "reviews": null,
              "ratings": 4.1,
              "image_count": 1,
              "product_name": "Sinew Nutrition Green Coffee Beans Powder for Weight Management - 200 g (Pack of 4)",
              "item_id": null,
              "brand": "sinew nutrition"
            },
            {
              "order": 140,
              "price": "Rs 850",
              "offer": "Rs 1,600",
              "page": 3,
              "link": "https://www.amazon.in/Starbucks-Verona-Capsule-Nespresso-Intensity/dp/B07W6Z4F9L/",
              "page_count": 48,
              "reviews": 8,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Starbucks Caffe Verona Coffee Dark Roast Coffee Capsule by Nespresso Intensity 10, 55g",
              "item_id": "B07W6Z4F9L",
              "brand": "starbucks"
            },
            {
              "order": 141,
              "price": "Rs 729.99",
              "offer": "Rs 1,400",
              "page": 3,
              "link": "https://www.amazon.in/Starbucks-Sumatra-Capsule-Nespresso-Intensity/dp/B07XZCGF71/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 3.8,
              "image_count": 3,
              "product_name": "Starbucks Single Origin Sumatra Coffee Dark Roast Coffee Capsule by Nespresso Intensity 10, 55g",
              "item_id": "B07XZCGF71",
              "brand": "starbucks"
            },
            {
              "order": 142,
              "price": "Rs 150",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Nescafe-Choco-Instant-Coffee-Premix/dp/B07PRJLQVH/",
              "page_count": 48,
              "reviews": 14,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Nescafe Gold Choco Mocha Instant Coffee Premix, 125g",
              "item_id": "B07PRJLQVH",
              "brand": "nescafe"
            },
            {
              "order": 143,
              "price": "Rs 451",
              "offer": "Rs 452",
              "page": 3,
              "link": "https://www.amazon.in/Hathmic-Madrasi-Instant-Coffee-370g/dp/B07ZBCG5F8/",
              "page_count": 48,
              "reviews": 54,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Hathmic Madrasi Instant Coffee, 370g",
              "item_id": "B07ZBCG5F8",
              "brand": "hathmic"
            },
            {
              "order": 144,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in/Neuherbs-Organic-Coffee-Weight-Management/dp/B01M011972/",
              "page_count": 48,
              "reviews": null,
              "ratings": 3.8,
              "image_count": 6,
              "product_name": "Neuherbs Green Coffee Beans Your Natural Immunity Booster And Weight Loss Partner: 200 G",
              "item_id": "B01M011972",
              "brand": "neuherbs"
            }
          ]
        for (let [idx, ds] of  resData.entries())
        {
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
        console.log(err)
        console.log('err')
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
    initDt2(){
      let self = this
      $('#myTable2').DataTable({
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                  .appendTo( $(column.footer()).empty() )
                  .on( 'change', function () {
                      var val = $.fn.dataTable.util.escapeRegex(
                          $(this).val()
                      );    
                      column
                          .search( val ? '^'+val+'$' : '', true, false )
                          .draw();
                  } );
              let arr = []    
              let sortedArr = []
              column.data().unique().sort().each( function ( d, j ) {
                var myVal = $(d).text()
                arr.push(myVal)
              } ); 
                
              sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
              for (let [idx, ds] of sortedArr.entries())
              {
                select.append( "<option value='"+ds+"'>"+ds+"</option>" )
              } 
          } );
        }
      });
    }
  }
}

</script>

<style scoped>

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
</style>
